import React from 'react';


export default function CustomLine(props) {
  return(

    <hr style={{borderColor:'#80949D',borderWidth:2,marginTop:40,marginBottom:40,width:'100%'}}/>
  )}
